import React from "react";

const AgentsSVG = ({ activeSvgColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 34 31"
      fill="none"
    >
      <circle
        cx="7.28592"
        cy="5"
        r="4"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2859 11L19.7859 5L32.2859 13.1818V14.5455H28.9918V30H10.2859"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2859 11H3.28592L1.28592 22H4.78592V30H10.2859V21.5H13.2859L11.2859 11Z"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.28592 11V17"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    // <svg
    //   width="19"
    //   height="19"
    //   viewBox="0 0 19 19"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M9.71294 18.013C9.52961 17.738 9.34628 17.5547 9.25461 17.2797C8.79628 16.4547 8.61295 15.538 8.61295 14.6214C8.61295 13.2464 9.16295 11.963 9.98795 10.9547C10.1713 10.7714 10.2629 10.588 10.4463 10.4964C10.4463 10.4047 10.9046 10.1297 11.1796 9.94638C12.8296 8.93805 13.8379 7.10471 13.6546 5.1797C13.5629 4.44636 13.3796 3.8047 13.1046 3.34636C12.3713 1.97136 11.0879 0.963029 9.52961 0.688029C6.2296 0.0463625 3.29627 2.52136 3.29627 5.7297C3.29627 7.47138 4.12126 8.93805 5.4046 9.85471C3.11294 10.6797 1.2796 12.4214 0.271269 14.713C-0.0953972 15.6297 -0.00373033 16.638 0.54627 17.463C1.2796 18.1964 2.19627 18.7464 3.29627 18.7464H10.4463C10.1713 18.4714 9.89628 18.288 9.71294 18.013Z"
    //     fill={activeSvgColor}
    //   />
    //   <path
    //     d="M18.1461 12.7877C17.9628 12.3294 17.5961 11.8711 17.2295 11.5044C16.4961 10.7711 15.3961 10.3127 14.2961 10.3127C13.9295 10.3127 13.4711 10.4044 13.1045 10.4961C12.8295 10.5877 12.4628 10.6794 12.1878 10.8627C11.9128 10.9544 11.7295 11.1377 11.4545 11.3211C10.5378 12.0544 9.98779 13.2461 9.98779 14.5294C9.98779 15.5377 10.3545 16.4544 10.9961 17.1877C11.2711 17.4627 11.5461 17.7377 11.8211 17.9211C12.4628 18.3794 13.1961 18.6544 13.9295 18.6544C14.0211 18.6544 14.1128 18.6544 14.2045 18.6544C16.4961 18.6544 18.4211 16.7294 18.4211 14.4377C18.5128 13.8877 18.3295 13.3377 18.1461 12.7877Z"
    //     fill={activeSvgColor}
    //   />
    //   <path
    //     d="M18.6048 11.1381C18.4215 10.9548 18.0548 10.8631 17.7798 11.0465C17.6881 11.0465 17.5965 11.1381 17.5048 11.2298L17.2298 11.5965L15.8548 13.1548L15.3048 13.7048L14.7548 14.2548L14.2965 14.8048L13.4715 13.8881C13.1965 13.6131 12.7381 13.5215 12.3715 13.7965C12.0965 14.0715 12.0048 14.5298 12.2798 14.8965L13.6548 16.4548C13.8381 16.6381 14.0215 16.7298 14.2048 16.7298C14.3881 16.7298 14.6631 16.6381 14.7548 16.4548L15.2131 15.9965L15.9465 15.1715L16.4965 14.5298L18.0548 12.7881L18.6048 12.2381C18.9715 11.8715 18.8798 11.4131 18.6048 11.1381Z"
    //     fill="white"
    //   />
    // </svg>
  );
};

export default AgentsSVG;
